import { styled } from '@mui/system'

export const GamesRow = styled('div')(({ theme }) => ({
    width: '30%',
    [theme.breakpoints.down('sm')]: {
        width: '100%',
      }
}))
